<template>
  <div class="table-list" v-loading="loading">
    <div class="table-content">
      <!-- 表格数据 -->
      <el-table
        :data="listData"
        header-cell-class-name="dark"
        :height="tableHeight"
        stripe
        border
      >
        <table-column label="序号" width="60" type="index"></table-column>
        <table-column prop="id" label="交易流水号" />
        <table-column prop="createtTime" label="交易时间" />
        <table-column prop="merId" label="商户号" />
        <table-column prop="merName" label="商户名称" />

        <table-column prop="merExpandUserName" label="商户拓展人员" />

        <table-column prop="merOperatorName" label="支付操作人" />
        <table-column prop="cardNo" label="支付账号">
          <!-- <span slot-scope="scope">
            {{ scope.row.cardNo | hideCorpPhone }}
          </span> -->
        </table-column>
        <table-column prop="supNo" label="供应商号" />
        <table-column prop="supName" label="供应商名称" />
        <table-column prop="supExpandUserName" label="供应商拓展人员" />
        <table-column prop="supOperatorName" label="受理操作人" />
        <table-column prop="terminalNo" label="受理账号">
          <!-- <span slot-scope="scope">
            {{ scope.row.terminalNo | hideCorpPhone }}
          </span> -->
        </table-column>
        <table-column prop="amount" label="交易金额" />
        <table-column prop="tradeType" label="交易类型">
          <span slot-scope="scope">{{
            scope.row.tradeType | filterTradeType
          }}</span>
        </table-column>
        <table-column prop="tradeWay" label="交易方式">
          <span slot-scope="scope">{{
            scope.row.tradeWay | filterTradeWay
          }}</span>
        </table-column>
        <table-column prop="endSettleTime" label="设定时间" />
        <table-column prop="settleTime" label="结算时间" />
        <table-column prop="state" label="交易状态">
          <span
            slot-scope="scope"
            :class="[
              {
                'color-red':
                  (scope.row && scope.row.state == 2) || scope.row.state == 4
              },
              {
                'color-yellow':
                  (scope.row && scope.row.state == 3) || scope.row.state == 7
              }
            ]"
            >{{ scope.row.state | filterState }}</span
          >
        </table-column>
        <table-column prop="applyCustomer" label="客服介入">
          <span slot-scope="scope">{{
            scope.row.applyCustomer | filApplyCustomer
          }}</span>
        </table-column>
        <table-column prop="errorMsg" label="返回信息" />
        <table-column prop="settleSt" label="清算状态">
          <template slot-scope="{ row }">
            <span
              v-if="row.settleSt"
              :class="{ 'color-red': row && row.settleSt == 2 }"
              >{{ row.settleSt | filterSettleState }}</span
            >
            <span v-else-if="row.state === 2" class="color-red">清算失败</span>
          </template>
        </table-column>
        <table-column prop="amountSettle" label="清算金额">
          <span slot-scope="{ row }">{{
            row.state === 2 ? '-' : row.amountSettle
          }}</span>
        </table-column>
        <table-column prop="bankName" label="渠道" />
        <table-column prop="comName" label="收单机构" />
        <table-column prop="serName" label="城市服务商" />
        <table-column prop="orderSource" label="交易来源">
          <span slot-scope="scope">{{
            scope.row.orderSource | filOrderSource
          }}</span>
        </table-column>

        <el-table-column width="80">
          <div slot="header" class="fixed-right-column">操作</div>
          <slot slot-scope="scope" :row="scope.row"></slot>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import mixin from '@/mixins/dataListHeight.js'
export default {
  mixins: [mixin],
  props: {
    listData: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },

  filters: {
    filOrderSource(value) {
      return { 0: 'POS', 1: 'APP' }[value]
    },
    filApplyCustomer(value) {
      return { 1: '无 ', 2: '响应中', 3: '已处理' }[value]
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/Common/tableList.scss';
</style>
